<template>
  <div class="job-finance">
    <div class="jf">
      <a href="javascript:;" class="toggle" @click="curTab = 'quotes'">QUOTES</a>
      <job-quotes v-if="curTab == 'quotes'" @close="curTab = ''"></job-quotes>
    </div>
    <div class="jf">
      <a href="javascript:;" class="toggle" @click="curTab = 'orders'">ORDERS</a>
      <job-orders v-if="curTab == 'orders'" @close="curTab = ''"></job-orders>
    </div>
    <div class="jf">
      <a href="javascript:;" class="toggle" @click="curTab = 'invoices'">INVOICES</a>
      <job-invoices v-if="curTab == 'invoices'" @close="curTab = ''"></job-invoices>
    </div>
  </div>
</template>

<script>
import JobQuotes from './JobQuotes.vue'
import JobOrders from './JobOrders.vue'
import JobInvoices from './JobInvoices.vue'

export default {
  components: {
    JobQuotes,
    JobOrders,
    JobInvoices,
  },
  data () {
    return {
      curTab: ''
    }
  },
  watch: {},
  computed: {},
  created () {},
  mounted () {},
  methods: {
    init () {

    }
  }
}
</script>
